import { icFilter2 } from '@vivareal/lina-icons'
import { mapState } from 'vuex'
import { hiddeBodyScroll } from '@/utils/scroll'

import mapper from '@/components/filters/filters.mapper'

import ozQuickFilters from '@/components/filters/oz-quick-filters'
import newAddressTypeahead from '@/components/filters/new-address-typeahead'
import { hasChangedFilters } from '@/utils/filters'
import ozFiltersModal from './components/oz-filters-modal'

export default {
  name: 'oz-filters-mobile',

  props: {
    glossary: { type: Object, required: true },
    isResultPage: { type: Boolean },
  },

  data () {
    return {
      countFilters: 0,
    }
  },

  created () {
    this.filtersCount(this.filters)
  },

  computed: {
    ...mapState({
      filters: (state) => state.results.filters,
      isShowRefineSearchOnMobile: (state) => state.results.isShowRefineSearchOnMobile,
      isShowMobileMapButton: (state) => state.results.isShowMobileMapButton,
    }),

    isMapAndModalFiltersOpen () {
      if (this.isShowRefineSearchOnMobile && this.isShowMobileMapButton) return true

      return false
    },

    onRefineSearch () {
      return this.isShowRefineSearchOnMobile
    },

    currentFilters () {
      this.filtersCount(this.filters)
      return this.filters
    },

    countFiltersString () {
      return this.countFilters.toString()
    },

    icon () {
      return this.countFilters ? null : icFilter2
    },
  },

  methods: {
    onRemoveFilters (businessFilters) {
      this.$emit('filters:update', mapper.transform(businessFilters))
      this.toggleFilters()
    },

    onFiltersUpdate (filters) {
      this.onUpdate(filters)
      this.toggleFilters()
    },

    onQuickFiltersUpdate (filters) {
      this.$emit('filters:update', filters)
    },

    onAddressUpdate (address) {
      this.onUpdate(address)
    },

    filtersCount (filters) {
      const appliedFilters = []
      const excludeFilters = [
        'addresses',
        'categoryPage',
        'from',
        'labels',
        'listingType',
        'page',
        'parentId',
        'portal',
        'q',
        'size',
        'sort',
        'unitTypesV3',
      ]

      const validFilters = Object.keys(filters).filter((key) => !excludeFilters.includes(key))

      validFilters.forEach((key) => {
        if (Array.isArray(filters[key])) {
          if (!filters[key].length) return
          appliedFilters.push(key)
        } else if (filters[key] && filters[key] !== 'UnitType_NONE') {
          appliedFilters.push(key)
        }
      })

      this.countFilters = appliedFilters.length
    },

    onUpdate (filters) {
      const changedFilters = hasChangedFilters(this.filters, filters)

      if (changedFilters) {
        const mergeFilters = { ...this.filters, ...filters }
        const filtersHasValue = Object.entries(mergeFilters)
          .reduce((treatedObj, [key, value]) => {
            if (key !== 'from' && (!value || value === 'undefined')) {
              return treatedObj
            }

            const mountObj = { [key]: value }
            return { ...treatedObj, ...mountObj }
          }, {})

        this.$emit('filters:update', mapper.transform(filtersHasValue))
      }
    },

    toggleFilters () {
      hiddeBodyScroll()
      this.$store.commit('results/setIsShowRefineSearchOnMobile', !this.isShowRefineSearchOnMobile)
      this.$store.commit('results/setIsShowMobileMapButton', !this.isShowRefineSearchOnMobile)
    },
  },

  components: {
    newAddressTypeahead,
    ozFiltersModal,
    ozQuickFilters,
  },
}
